<div class="row psu-container">
    <div class="custom-button">
        <!-- <div *ngIf="!defaultRestoring" class="restore">
            <span class="reset signifyBookmd" (click)="resetDefault()">Restore default</span>
        </div>
        <div *ngIf="defaultRestoring" [ngClass]="{'defaultRestoring': defaultRestoring}">
            <span  class="signifyBookmd" (click)="resetDefault()">Default</span>
        </div> -->
        <div id="DaliPSU-enableFeature-text" class="rSet">Enable feature
            <input type="checkbox" class="primary-checkbox" [checked]="ngModelval['Enabled']" id ="enablePsu" (change)="rSetChanged($event.target.checked)"/>
            <label class="enable-checkbox" for ="enablePsu"  aria-label="Enable feature"><span id="DaliPSU-enableFeature-checkbox" class="extra-border-enablefeat"></span></label>
        </div>
    </div>
    <span class="col-1 aoc-tooltips" *ngIf="!defaultRestoring">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="defaultRestoring">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>
    <div class="col-8"></div>
    <div class="col-1"></div>
</div>

<br>
<div id="srpsu_checkbox_list" class="row psu-container paramter-custom" *ngFor="let param of psuParameter">
    <div id="DaliPSU-heartBeat-text" class="col-2 paddingLeftPSU" *ngIf="param === 'Heart beat'">
            <span [ngClass]="{'param-name-disabled': !checkboxdefaultValue}">{{param}}</span>
        <input [checked]="paramterCheckedValueHB" [disabled]="!checkboxdefaultValue"  type="checkbox" class="primary-checkbox" id ="srpsu_heartBeat" (change)="paramterChecked($event.target.checked, param)"/>
        <label class="setting-checkbox" for ="srpsu_heartBeat"  aria-label="Heart Beat"><span id="DaliPSU-heartBeat-checkbox" [ngClass]="{'diableCheckbox': !checkboxdefaultValue}" class="extra-border-enablefeat"></span></label>
    </div>
    <div class="col-2 paddingLeftPSU" *ngIf="param === 'Last gasp'">
            <span [ngClass]="{'param-name-disabled': !checkboxdefaultValue}">{{param}}</span>
        <input [checked]="paramterCheckedValueLG" [disabled]="!checkboxdefaultValue"  type="checkbox" class="primary-checkbox" id ="srpsu_lastGasp" (change)="paramterChecked($event.target.checked, param)"/>
        <label class="setting-checkbox" for ="srpsu_lastGasp"  aria-label="Last Gasp"><span [ngClass]="{'diableCheckbox': !checkboxdefaultValue}" class="extra-border-enablefeat"></span></label>
    </div>
</div>
<br>
